// extracted by css-extract-rspack-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_YzP","cls2":"PostEngagementFollowPrompt-cls2_84C PostEngagementFollowPrompt-cls1_YzP"};